import React, { Component } from "react";
import { connect } from "react-redux";
import { REACT_APP_RESOURCE_URL } from "../../shared/vars";

// CSS
import "../../css/banners.css";

// picturefill
// if(typeof window !== 'undefined'){
// let picturefill = require('picturefill')
// }

// import picturefill from 'picturefill'

class Banners extends Component {
	showPanoWrapper(item, i) {
		const { href } = item;

		if (href) {
			return (
				<a key={i} href={href} className="pano_main">
					{this.showPicture(item)}
				</a>
			);
		} else {
			return (
				<div key={i} className="pano_main">
					{this.showPicture(item)}
				</div>
			);
		}
	}

	showPicture(item) {
		const { sizes } = item;

		let sourcesFull;
		if (sizes.full) {
			sourcesFull = (
				<source
					src={REACT_APP_RESOURCE_URL + sizes.full.src}
					media="(min-width: 500px)"
				/>
			);
		}

		let sourcesMobile;
		if (sizes.mobile) {
			sourcesMobile = <source src={REACT_APP_RESOURCE_URL + sizes.mobile.src} />;
		}

		let imageMobile;
		if (sizes.mobile) {
			imageMobile = (
				<img
					src={REACT_APP_RESOURCE_URL + sizes.full.src}
					alt={REACT_APP_RESOURCE_URL + sizes.full.src}
				/>
			);
		}



		return (
			<picture>
				{/*<!--[if IE 9]><video style="display: none"><![endif]-->*/}
				{sourcesFull}
				{sourcesMobile}
				{/*<!--[if IE 9]></video><![endif]-->*/}
				{imageMobile}
			</picture>
		);
	}

	showBanners(banner, i) {
		return this.showPanoWrapper(banner, i);
	}

	render() {
		if (this.props.banners.banners) {
			return (
				<div id="banner_wrap">
					{this.props.banners.banners.map((banner, i) => {
						return this.showBanners(banner, i);
					})}
				</div>
			);
		} else {
			return null;
		}
	}
}

const mapStateToProps = state => {
	return {
		banners: state.banners
	};
};

export default connect(mapStateToProps)(Banners);



// WEBPACK FOOTER //
// ./src/components/home/Banners.js